var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.26 0c3.098 0 5.623 2.544 5.736 5.726l.004.223v8.102c0 3.211-2.454 5.828-5.524 5.945L14.26 20H5.74C2.642 20 .117 17.456.004 14.274L0 14.051V5.95C0 2.738 2.454.12 5.524.004L5.74 0h8.52zm0 1H5.74C3.2 1 1.115 3.09 1.005 5.728L1 5.948v8.103c0 2.667 2.017 4.83 4.53 4.944l.21.005h8.52c2.54 0 4.625-2.09 4.735-4.728l.005-.22V5.948c0-2.667-2.017-4.83-4.53-4.944L14.26 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.483 7.766a5.013 5.013 0 015.206-2.705 5.025 5.025 0 014.231 4.237 5.039 5.039 0 01-2.718 5.247 5.005 5.005 0 01-5.78-.931 5.048 5.048 0 01-.94-5.848zm5.06-1.716a4.013 4.013 0 00-4.167 2.166 4.048 4.048 0 00.752 4.69 4.005 4.005 0 004.625.745 4.039 4.039 0 002.178-4.206 4.025 4.025 0 00-3.388-3.395zm4.922-2.65a1.16 1.16 0 011.162 1.159 1.16 1.16 0 01-1.083 1.156l-.105.002a1.16 1.16 0 01-1.162-1.158 1.16 1.16 0 011.083-1.156l.08-.003h.025z"
  }))));
}

export default SvgInstagram;